export default function auth({ store, next }) {
    if(!store.getters['Profile/authenticated'] && !localStorage.getItem('token')){
        return next({
            name: 'Login'
        })
    }

    return next()
}